export const selectedStandardTemplateSelector = ({ standardTemplates = {} } = {}) =>
  standardTemplates.selectedStandardTemplate;
